"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    // @ts-ignore //TODO: check type
    var $video = $('#videoAutoplay')[0];
    if ($video) {
        $(window).scroll(function () {
            if (window.IsInViewport($video)) {
                $video.play();
            }
            else {
                $video.pause();
                $video.currentTime = 0;
            }
        });
    }
};
exports.init = init;
